<template>
  <div class="flex gf_pricing-faq">
     <div class="flex flex-col gf_pricing-faq-left">
       <div class="gf_pricing-faq-left-title">Frequently asked questions</div>
       <div class="gf_pricing-faq-left-desc">Find the answers to your inquiries about our pricing plans, features, and support.</div>
       <div class="flex gf_pricing-faq-left-contact-support items-center">
         <div class="gf_pricing-faq-left-contact-support-icon">
           <img class="obj-contain" src="../assets/contact.svg" alt="Contact">
         </div>
         <div @click="openLiveChat" class="gf_pricing-faq-left-contact-support-text">
           Contact support
         </div>
       </div>
     </div>
    <div class="flex flex-col gf_pricing-faq-right">
      <PricingAccordionItem
        v-for="(item, key) in fqaList"
        :key="key"
        :index="key"
        :item="item"
      />
    </div>
  </div>
</template>

<script>
import plan from "@/modules/Pricing/mixins/plan";
import PricingAccordionItem from "@/modules/Pricing/components/PricingAccordionItem.vue";
import {mapGetters} from "vuex";

export default {
  name: "PricingFaqAccordion",
  components: {PricingAccordionItem},
  mixins: [plan()],
  computed: {
    ...mapGetters("dashboard", {
      isBFCM: "isBFCM",
    }),
    fqaList() {
      const rawList = [...this.getFaqs.left, ...this.getFaqs.right]
      if (!this.isBFCM) return rawList.filter(i => !i.isBFCM)

      return rawList
    }
  },
  methods: {
    openLiveChat() {
      this.$chatbox.show();
    },
  }
}
</script>

<style lang="scss" scoped>
  .items-center {
    align-items: center;
  }
  .justify-center {
    justify-content: center;
  }
  .flex {
    display: flex;
    &-col {
      display: flex;
      flex-direction: column;
    }
  }
  .obj-contain {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
  .gf_pricing {
    &-faq {
      width: 100%;
      gap: 20px;
      &-left {
        width: calc((100% - 20px) / 2);
        &-contact-support {
          gap: 4px;
          &-icon {
            width: 16px;
            height: 16px;
          }
          &-text {
            color: #3C67FF;
            text-align: right;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 150%;
            cursor: pointer;
            &:hover {
              color: #0A3BE7;
            }
          }
        }
        &-title {
          color: #212121;
          font-size: 32px;
          font-style: normal;
          font-weight: 600;
          line-height: 120%;
          margin-bottom: 16px;
        }
        &-desc {
          color: #212121;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
          margin-bottom: 24px;
        }
      }
      &-right {
        width: calc((100% - 20px) / 2)
      }
    }
  }
</style>
